/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportRequestGenericOntology } from '../../models/export-request-generic-ontology';

export interface UpdateExportRequestAlarmOntology$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected ontology
 */
  ontologyUid: string;
  
    /**
     * Body for new ontology on demand of export
     */
    body: ExportRequestGenericOntology
}

export function updateExportRequestAlarmOntology(http: HttpClient, rootUrl: string, params: UpdateExportRequestAlarmOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateExportRequestAlarmOntology.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('ontologyUid', params.ontologyUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateExportRequestAlarmOntology.PATH = '/export-request/{uid}/ontology/alarm/{ontologyUid}';
